export const userDetailsValidation = (createdUser, setError) => {
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const regexMobile = /^\+1\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const regexPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,}$/;
  let accessCreate = true;
  if (createdUser.firstName == "") {
    setError((prev) => ({ ...prev, firstName: true }));
    accessCreate = false;
  }
  if (createdUser.lastName == "") {
    setError((prev) => ({ ...prev, lastName: true }));
    accessCreate = false;
  }
  if (createdUser.userName == "") {
    setError((prev) => ({ ...prev, userName: true }));
    accessCreate = false;
  }
  if (createdUser.email == "") {
    setError((prev) => ({ ...prev, email: true }));
    accessCreate = false;
  } else if (!regexEmail.test(createdUser.email)) {
    setError((prev) => ({ ...prev, emailMissMatch: true }));
    accessCreate = false;
  }
  if (createdUser.password == "") {
    setError((prev) => ({ ...prev, password: true }));
    accessCreate = false;
  } else if (!regexPassword.test(createdUser.password)) {
    setError((prev) => ({ ...prev, passwordNotValid: true }));
    accessCreate = false;
  }
  if (createdUser.Cpassword == "") {
    setError((prev) => ({ ...prev, Cpassword: true }));
    accessCreate = false;
  }
  if (createdUser.password !== createdUser.Cpassword) {
    setError((prev) => ({ ...prev, passwordMissMatch: true }));
    accessCreate = false;
  }
  if (createdUser.mobile == "") {
    setError((prev) => ({ ...prev, mobile: true }));
    accessCreate = false;
  } else if (!regexMobile.test(createdUser.mobile)) {
    setError((prev) => ({ ...prev, mobileNotValid: true }));
    accessCreate = false;
  }
  if (createdUser.role == "") {
    setError((prev) => ({ ...prev, role: true }));
    accessCreate = false;
  }
  return accessCreate;
};
